module.exports = __webpack_public_path__ + "img/pherrol.7b23b9cd.jpg";